import { jsx as m, Fragment as ze, jsxs as J } from "react/jsx-runtime";
import * as a from "react";
import F, { forwardRef as ye, isValidElement as Ye, useRef as Q, useState as B, Children as k, useEffect as K } from "react";
import "react-dom";
function Ze(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var pe = { exports: {} };
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
var me;
function He() {
  return me || (me = 1, function(e) {
    (function() {
      var t = {}.hasOwnProperty;
      function n() {
        for (var r = "", i = 0; i < arguments.length; i++) {
          var c = arguments[i];
          c && (r = s(r, o.call(this, c)));
        }
        return r;
      }
      function o(r) {
        if (typeof r == "string" || typeof r == "number")
          return this && this[r] || r;
        if (typeof r != "object")
          return "";
        if (Array.isArray(r))
          return n.apply(this, r);
        if (r.toString !== Object.prototype.toString && !r.toString.toString().includes("[native code]"))
          return r.toString();
        var i = "";
        for (var c in r)
          t.call(r, c) && r[c] && (i = s(i, this && this[c] || c));
        return i;
      }
      function s(r, i) {
        return i ? r ? r + " " + i : r + i : r;
      }
      e.exports ? (n.default = n, e.exports = n) : window.classNames = n;
    })();
  }(pe)), pe.exports;
}
var Xe = He();
const Je = /* @__PURE__ */ Ze(Xe), Qe = {
  "purpur-icon": "_purpur-icon_8u1lq_1",
  "purpur-icon--xxs": "_purpur-icon--xxs_8u1lq_4",
  "purpur-icon--xs": "_purpur-icon--xs_8u1lq_8",
  "purpur-icon--sm": "_purpur-icon--sm_8u1lq_12",
  "purpur-icon--md": "_purpur-icon--md_8u1lq_16",
  "purpur-icon--lg": "_purpur-icon--lg_8u1lq_20",
  "purpur-icon--xl": "_purpur-icon--xl_8u1lq_24"
}, et = Je.bind(Qe), ge = "purpur-icon", tt = "md", nt = (e) => e.filter((t) => Object.keys(t).length >= 1).map((t) => `${t.name}="${t.value}"`).join(" "), rt = ({ content: e = "", title: t } = {}) => {
  const n = [
    { name: "xmlns", value: "http://www.w3.org/2000/svg" },
    { name: "fill", value: "currentColor" },
    { name: "viewBox", value: "0 0 24 24" },
    t ? { name: "role", value: "img" } : { name: "aria-hidden", value: "true" }
  ], o = t ? `<title>${t}</title>` : "";
  return `<svg ${nt(n)}>${o}${e}</svg>`;
}, ot = (e) => e.replace(/<(\/?)svg([^>]*)>/g, "").trim(), we = ({
  ["data-testid"]: e,
  svg: t,
  allyTitle: n,
  className: o,
  size: s = tt,
  ...r
}) => {
  const i = rt({
    content: ot(t.svg),
    title: n
  }), c = et(o, ge, `${ge}--${s}`);
  return /* @__PURE__ */ m(
    "span",
    {
      className: c,
      "data-testid": e,
      dangerouslySetInnerHTML: { __html: i },
      ...r
    }
  );
};
we.displayName = "Icon";
const st = {
  name: "chevron-left",
  svg: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"><path fill-rule="evenodd" d="M16.175 3.905a.9.9 0 0 1-.08 1.27L8.36 12l7.736 6.825a.9.9 0 0 1-1.191 1.35l-8.5-7.5a.9.9 0 0 1 0-1.35l8.5-7.5a.9.9 0 0 1 1.27.08Z" clip-rule="evenodd"/></svg>',
  keywords: ["chevron-left"],
  category: "utility"
}, it = {
  name: "chevron-right",
  svg: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"><path fill-rule="evenodd" d="M7.809 3.924a.9.9 0 0 0 .115 1.267L16.094 12l-8.17 6.809a.9.9 0 0 0 1.152 1.382l9-7.5a.9.9 0 0 0 0-1.382l-9-7.5a.9.9 0 0 0-1.267.115Z" clip-rule="evenodd"/></svg>',
  keywords: ["chevron-right"],
  category: "utility"
};
function A(e, t, { checkForDefaultPrevented: n = !0 } = {}) {
  return function(s) {
    if (e == null || e(s), n === !1 || !s.defaultPrevented)
      return t == null ? void 0 : t(s);
  };
}
function se(e, t = []) {
  let n = [];
  function o(r, i) {
    const c = a.createContext(i), l = n.length;
    n = [...n, i];
    const u = (d) => {
      var h;
      const { scope: _, children: v, ...f } = d, b = ((h = _ == null ? void 0 : _[e]) == null ? void 0 : h[l]) || c, C = a.useMemo(() => f, Object.values(f));
      return /* @__PURE__ */ m(b.Provider, { value: C, children: v });
    };
    u.displayName = r + "Provider";
    function g(d, _) {
      var b;
      const v = ((b = _ == null ? void 0 : _[e]) == null ? void 0 : b[l]) || c, f = a.useContext(v);
      if (f) return f;
      if (i !== void 0) return i;
      throw new Error(`\`${d}\` must be used within \`${r}\``);
    }
    return [u, g];
  }
  const s = () => {
    const r = n.map((i) => a.createContext(i));
    return function(c) {
      const l = (c == null ? void 0 : c[e]) || r;
      return a.useMemo(
        () => ({ [`__scope${e}`]: { ...c, [e]: l } }),
        [c, l]
      );
    };
  };
  return s.scopeName = e, [o, ct(s, ...t)];
}
function ct(...e) {
  const t = e[0];
  if (e.length === 1) return t;
  const n = () => {
    const o = e.map((s) => ({
      useScope: s(),
      scopeName: s.scopeName
    }));
    return function(r) {
      const i = o.reduce((c, { useScope: l, scopeName: u }) => {
        const d = l(r)[`__scope${u}`];
        return { ...c, ...d };
      }, {});
      return a.useMemo(() => ({ [`__scope${t.scopeName}`]: i }), [i]);
    };
  };
  return n.scopeName = t.scopeName, n;
}
function _e(e, t) {
  if (typeof e == "function")
    return e(t);
  e != null && (e.current = t);
}
function Ce(...e) {
  return (t) => {
    let n = !1;
    const o = e.map((s) => {
      const r = _e(s, t);
      return !n && typeof r == "function" && (n = !0), r;
    });
    if (n)
      return () => {
        for (let s = 0; s < o.length; s++) {
          const r = o[s];
          typeof r == "function" ? r() : _e(e[s], null);
        }
      };
  };
}
function Y(...e) {
  return a.useCallback(Ce(...e), e);
}
var Z = a.forwardRef((e, t) => {
  const { children: n, ...o } = e, s = a.Children.toArray(n), r = s.find(ut);
  if (r) {
    const i = r.props.children, c = s.map((l) => l === r ? a.Children.count(i) > 1 ? a.Children.only(null) : a.isValidElement(i) ? i.props.children : null : l);
    return /* @__PURE__ */ m(ne, { ...o, ref: t, children: a.isValidElement(i) ? a.cloneElement(i, void 0, c) : null });
  }
  return /* @__PURE__ */ m(ne, { ...o, ref: t, children: n });
});
Z.displayName = "Slot";
var ne = a.forwardRef((e, t) => {
  const { children: n, ...o } = e;
  if (a.isValidElement(n)) {
    const s = dt(n), r = lt(o, n.props);
    return n.type !== a.Fragment && (r.ref = t ? Ce(t, s) : s), a.cloneElement(n, r);
  }
  return a.Children.count(n) > 1 ? a.Children.only(null) : null;
});
ne.displayName = "SlotClone";
var at = ({ children: e }) => /* @__PURE__ */ m(ze, { children: e });
function ut(e) {
  return a.isValidElement(e) && e.type === at;
}
function lt(e, t) {
  const n = { ...t };
  for (const o in t) {
    const s = e[o], r = t[o];
    /^on[A-Z]/.test(o) ? s && r ? n[o] = (...c) => {
      r(...c), s(...c);
    } : s && (n[o] = s) : o === "style" ? n[o] = { ...s, ...r } : o === "className" && (n[o] = [s, r].filter(Boolean).join(" "));
  }
  return { ...e, ...n };
}
function dt(e) {
  var o, s;
  let t = (o = Object.getOwnPropertyDescriptor(e.props, "ref")) == null ? void 0 : o.get, n = t && "isReactWarning" in t && t.isReactWarning;
  return n ? e.ref : (t = (s = Object.getOwnPropertyDescriptor(e, "ref")) == null ? void 0 : s.get, n = t && "isReactWarning" in t && t.isReactWarning, n ? e.props.ref : e.props.ref || e.ref);
}
function ft(e) {
  const t = e + "CollectionProvider", [n, o] = se(t), [s, r] = n(
    t,
    { collectionRef: { current: null }, itemMap: /* @__PURE__ */ new Map() }
  ), i = (v) => {
    const { scope: f, children: b } = v, C = F.useRef(null), h = F.useRef(/* @__PURE__ */ new Map()).current;
    return /* @__PURE__ */ m(s, { scope: f, itemMap: h, collectionRef: C, children: b });
  };
  i.displayName = t;
  const c = e + "CollectionSlot", l = F.forwardRef(
    (v, f) => {
      const { scope: b, children: C } = v, h = r(c, b), y = Y(f, h.collectionRef);
      return /* @__PURE__ */ m(Z, { ref: y, children: C });
    }
  );
  l.displayName = c;
  const u = e + "CollectionItemSlot", g = "data-radix-collection-item", d = F.forwardRef(
    (v, f) => {
      const { scope: b, children: C, ...h } = v, y = F.useRef(null), M = Y(f, y), w = r(u, b);
      return F.useEffect(() => (w.itemMap.set(y, { ref: y, ...h }), () => void w.itemMap.delete(y))), /* @__PURE__ */ m(Z, { [g]: "", ref: M, children: C });
    }
  );
  d.displayName = u;
  function _(v) {
    const f = r(e + "CollectionConsumer", v);
    return F.useCallback(() => {
      const C = f.collectionRef.current;
      if (!C) return [];
      const h = Array.from(C.querySelectorAll(`[${g}]`));
      return Array.from(f.itemMap.values()).sort(
        (w, N) => h.indexOf(w.ref.current) - h.indexOf(N.ref.current)
      );
    }, [f.collectionRef, f.itemMap]);
  }
  return [
    { Provider: i, Slot: l, ItemSlot: d },
    _,
    o
  ];
}
var re = globalThis != null && globalThis.document ? a.useLayoutEffect : () => {
}, pt = a.useId || (() => {
}), mt = 0;
function Ie(e) {
  const [t, n] = a.useState(pt());
  return re(() => {
    n((o) => o ?? String(mt++));
  }, [e]), t ? `radix-${t}` : "";
}
var gt = [
  "a",
  "button",
  "div",
  "form",
  "h2",
  "h3",
  "img",
  "input",
  "label",
  "li",
  "nav",
  "ol",
  "p",
  "span",
  "svg",
  "ul"
], D = gt.reduce((e, t) => {
  const n = a.forwardRef((o, s) => {
    const { asChild: r, ...i } = o, c = r ? Z : t;
    return typeof window < "u" && (window[Symbol.for("radix-ui")] = !0), /* @__PURE__ */ m(c, { ...i, ref: s });
  });
  return n.displayName = `Primitive.${t}`, { ...e, [t]: n };
}, {});
function ie(e) {
  const t = a.useRef(e);
  return a.useEffect(() => {
    t.current = e;
  }), a.useMemo(() => (...n) => {
    var o;
    return (o = t.current) == null ? void 0 : o.call(t, ...n);
  }, []);
}
function Se({
  prop: e,
  defaultProp: t,
  onChange: n = () => {
  }
}) {
  const [o, s] = _t({ defaultProp: t, onChange: n }), r = e !== void 0, i = r ? e : o, c = ie(n), l = a.useCallback(
    (u) => {
      if (r) {
        const d = typeof u == "function" ? u(e) : u;
        d !== e && c(d);
      } else
        s(u);
    },
    [r, e, s, c]
  );
  return [i, l];
}
function _t({
  defaultProp: e,
  onChange: t
}) {
  const n = a.useState(e), [o] = n, s = a.useRef(o), r = ie(t);
  return a.useEffect(() => {
    s.current !== o && (r(o), s.current = o);
  }, [o, s, r]), n;
}
var vt = a.createContext(void 0);
function Ne(e) {
  const t = a.useContext(vt);
  return e || t || "ltr";
}
var ee = "rovingFocusGroup.onEntryFocus", bt = { bubbles: !1, cancelable: !0 }, H = "RovingFocusGroup", [oe, Re, ht] = ft(H), [yt, Te] = se(
  H,
  [ht]
), [wt, Ct] = yt(H), xe = a.forwardRef(
  (e, t) => /* @__PURE__ */ m(oe.Provider, { scope: e.__scopeRovingFocusGroup, children: /* @__PURE__ */ m(oe.Slot, { scope: e.__scopeRovingFocusGroup, children: /* @__PURE__ */ m(It, { ...e, ref: t }) }) })
);
xe.displayName = H;
var It = a.forwardRef((e, t) => {
  const {
    __scopeRovingFocusGroup: n,
    orientation: o,
    loop: s = !1,
    dir: r,
    currentTabStopId: i,
    defaultCurrentTabStopId: c,
    onCurrentTabStopIdChange: l,
    onEntryFocus: u,
    preventScrollOnEntryFocus: g = !1,
    ...d
  } = e, _ = a.useRef(null), v = Y(t, _), f = Ne(r), [b = null, C] = Se({
    prop: i,
    defaultProp: c,
    onChange: l
  }), [h, y] = a.useState(!1), M = ie(u), w = Re(n), N = a.useRef(!1), [q, U] = a.useState(0);
  return a.useEffect(() => {
    const I = _.current;
    if (I)
      return I.addEventListener(ee, M), () => I.removeEventListener(ee, M);
  }, [M]), /* @__PURE__ */ m(
    wt,
    {
      scope: n,
      orientation: o,
      dir: f,
      loop: s,
      currentTabStopId: b,
      onItemFocus: a.useCallback(
        (I) => C(I),
        [C]
      ),
      onItemShiftTab: a.useCallback(() => y(!0), []),
      onFocusableItemAdd: a.useCallback(
        () => U((I) => I + 1),
        []
      ),
      onFocusableItemRemove: a.useCallback(
        () => U((I) => I - 1),
        []
      ),
      children: /* @__PURE__ */ m(
        D.div,
        {
          tabIndex: h || q === 0 ? -1 : 0,
          "data-orientation": o,
          ...d,
          ref: v,
          style: { outline: "none", ...e.style },
          onMouseDown: A(e.onMouseDown, () => {
            N.current = !0;
          }),
          onFocus: A(e.onFocus, (I) => {
            const X = !N.current;
            if (I.target === I.currentTarget && X && !h) {
              const $ = new CustomEvent(ee, bt);
              if (I.currentTarget.dispatchEvent($), !$.defaultPrevented) {
                const L = w().filter((x) => x.focusable), V = L.find((x) => x.active), j = L.find((x) => x.id === b), W = [V, j, ...L].filter(
                  Boolean
                ).map((x) => x.ref.current);
                Me(W, g);
              }
            }
            N.current = !1;
          }),
          onBlur: A(e.onBlur, () => y(!1))
        }
      )
    }
  );
}), Ee = "RovingFocusGroupItem", Ae = a.forwardRef(
  (e, t) => {
    const {
      __scopeRovingFocusGroup: n,
      focusable: o = !0,
      active: s = !1,
      tabStopId: r,
      ...i
    } = e, c = Ie(), l = r || c, u = Ct(Ee, n), g = u.currentTabStopId === l, d = Re(n), { onFocusableItemAdd: _, onFocusableItemRemove: v } = u;
    return a.useEffect(() => {
      if (o)
        return _(), () => v();
    }, [o, _, v]), /* @__PURE__ */ m(
      oe.ItemSlot,
      {
        scope: n,
        id: l,
        focusable: o,
        active: s,
        children: /* @__PURE__ */ m(
          D.span,
          {
            tabIndex: g ? 0 : -1,
            "data-orientation": u.orientation,
            ...i,
            ref: t,
            onMouseDown: A(e.onMouseDown, (f) => {
              o ? u.onItemFocus(l) : f.preventDefault();
            }),
            onFocus: A(e.onFocus, () => u.onItemFocus(l)),
            onKeyDown: A(e.onKeyDown, (f) => {
              if (f.key === "Tab" && f.shiftKey) {
                u.onItemShiftTab();
                return;
              }
              if (f.target !== f.currentTarget) return;
              const b = Rt(f, u.orientation, u.dir);
              if (b !== void 0) {
                if (f.metaKey || f.ctrlKey || f.altKey || f.shiftKey) return;
                f.preventDefault();
                let h = d().filter((y) => y.focusable).map((y) => y.ref.current);
                if (b === "last") h.reverse();
                else if (b === "prev" || b === "next") {
                  b === "prev" && h.reverse();
                  const y = h.indexOf(f.currentTarget);
                  h = u.loop ? Tt(h, y + 1) : h.slice(y + 1);
                }
                setTimeout(() => Me(h));
              }
            })
          }
        )
      }
    );
  }
);
Ae.displayName = Ee;
var St = {
  ArrowLeft: "prev",
  ArrowUp: "prev",
  ArrowRight: "next",
  ArrowDown: "next",
  PageUp: "first",
  Home: "first",
  PageDown: "last",
  End: "last"
};
function Nt(e, t) {
  return t !== "rtl" ? e : e === "ArrowLeft" ? "ArrowRight" : e === "ArrowRight" ? "ArrowLeft" : e;
}
function Rt(e, t, n) {
  const o = Nt(e.key, n);
  if (!(t === "vertical" && ["ArrowLeft", "ArrowRight"].includes(o)) && !(t === "horizontal" && ["ArrowUp", "ArrowDown"].includes(o)))
    return St[o];
}
function Me(e, t = !1) {
  const n = document.activeElement;
  for (const o of e)
    if (o === n || (o.focus({ preventScroll: t }), document.activeElement !== n)) return;
}
function Tt(e, t) {
  return e.map((n, o) => e[(t + o) % e.length]);
}
var xt = xe, Et = Ae;
function At(e, t) {
  return a.useReducer((n, o) => t[n][o] ?? n, e);
}
var Pe = (e) => {
  const { present: t, children: n } = e, o = Mt(t), s = typeof n == "function" ? n({ present: o.isPresent }) : a.Children.only(n), r = Y(o.ref, Pt(s));
  return typeof n == "function" || o.isPresent ? a.cloneElement(s, { ref: r }) : null;
};
Pe.displayName = "Presence";
function Mt(e) {
  const [t, n] = a.useState(), o = a.useRef({}), s = a.useRef(e), r = a.useRef("none"), i = e ? "mounted" : "unmounted", [c, l] = At(i, {
    mounted: {
      UNMOUNT: "unmounted",
      ANIMATION_OUT: "unmountSuspended"
    },
    unmountSuspended: {
      MOUNT: "mounted",
      ANIMATION_END: "unmounted"
    },
    unmounted: {
      MOUNT: "mounted"
    }
  });
  return a.useEffect(() => {
    const u = z(o.current);
    r.current = c === "mounted" ? u : "none";
  }, [c]), re(() => {
    const u = o.current, g = s.current;
    if (g !== e) {
      const _ = r.current, v = z(u);
      e ? l("MOUNT") : v === "none" || (u == null ? void 0 : u.display) === "none" ? l("UNMOUNT") : l(g && _ !== v ? "ANIMATION_OUT" : "UNMOUNT"), s.current = e;
    }
  }, [e, l]), re(() => {
    if (t) {
      let u;
      const g = t.ownerDocument.defaultView ?? window, d = (v) => {
        const b = z(o.current).includes(v.animationName);
        if (v.target === t && b && (l("ANIMATION_END"), !s.current)) {
          const C = t.style.animationFillMode;
          t.style.animationFillMode = "forwards", u = g.setTimeout(() => {
            t.style.animationFillMode === "forwards" && (t.style.animationFillMode = C);
          });
        }
      }, _ = (v) => {
        v.target === t && (r.current = z(o.current));
      };
      return t.addEventListener("animationstart", _), t.addEventListener("animationcancel", d), t.addEventListener("animationend", d), () => {
        g.clearTimeout(u), t.removeEventListener("animationstart", _), t.removeEventListener("animationcancel", d), t.removeEventListener("animationend", d);
      };
    } else
      l("ANIMATION_END");
  }, [t, l]), {
    isPresent: ["mounted", "unmountSuspended"].includes(c),
    ref: a.useCallback((u) => {
      u && (o.current = getComputedStyle(u)), n(u);
    }, [])
  };
}
function z(e) {
  return (e == null ? void 0 : e.animationName) || "none";
}
function Pt(e) {
  var o, s;
  let t = (o = Object.getOwnPropertyDescriptor(e.props, "ref")) == null ? void 0 : o.get, n = t && "isReactWarning" in t && t.isReactWarning;
  return n ? e.ref : (t = (s = Object.getOwnPropertyDescriptor(e, "ref")) == null ? void 0 : s.get, n = t && "isReactWarning" in t && t.isReactWarning, n ? e.props.ref : e.props.ref || e.ref);
}
var ce = "Tabs", [Ot, nn] = se(ce, [
  Te
]), Oe = Te(), [Ft, ae] = Ot(ce), Fe = a.forwardRef(
  (e, t) => {
    const {
      __scopeTabs: n,
      value: o,
      onValueChange: s,
      defaultValue: r,
      orientation: i = "horizontal",
      dir: c,
      activationMode: l = "automatic",
      ...u
    } = e, g = Ne(c), [d, _] = Se({
      prop: o,
      onChange: s,
      defaultProp: r
    });
    return /* @__PURE__ */ m(
      Ft,
      {
        scope: n,
        baseId: Ie(),
        value: d,
        onValueChange: _,
        orientation: i,
        dir: g,
        activationMode: l,
        children: /* @__PURE__ */ m(
          D.div,
          {
            dir: g,
            "data-orientation": i,
            ...u,
            ref: t
          }
        )
      }
    );
  }
);
Fe.displayName = ce;
var $e = "TabsList", De = a.forwardRef(
  (e, t) => {
    const { __scopeTabs: n, loop: o = !0, ...s } = e, r = ae($e, n), i = Oe(n);
    return /* @__PURE__ */ m(
      xt,
      {
        asChild: !0,
        ...i,
        orientation: r.orientation,
        dir: r.dir,
        loop: o,
        children: /* @__PURE__ */ m(
          D.div,
          {
            role: "tablist",
            "aria-orientation": r.orientation,
            ...s,
            ref: t
          }
        )
      }
    );
  }
);
De.displayName = $e;
var qe = "TabsTrigger", Le = a.forwardRef(
  (e, t) => {
    const { __scopeTabs: n, value: o, disabled: s = !1, ...r } = e, i = ae(qe, n), c = Oe(n), l = Ue(i.baseId, o), u = je(i.baseId, o), g = o === i.value;
    return /* @__PURE__ */ m(
      Et,
      {
        asChild: !0,
        ...c,
        focusable: !s,
        active: g,
        children: /* @__PURE__ */ m(
          D.button,
          {
            type: "button",
            role: "tab",
            "aria-selected": g,
            "aria-controls": u,
            "data-state": g ? "active" : "inactive",
            "data-disabled": s ? "" : void 0,
            disabled: s,
            id: l,
            ...r,
            ref: t,
            onMouseDown: A(e.onMouseDown, (d) => {
              !s && d.button === 0 && d.ctrlKey === !1 ? i.onValueChange(o) : d.preventDefault();
            }),
            onKeyDown: A(e.onKeyDown, (d) => {
              [" ", "Enter"].includes(d.key) && i.onValueChange(o);
            }),
            onFocus: A(e.onFocus, () => {
              const d = i.activationMode !== "manual";
              !g && !s && d && i.onValueChange(o);
            })
          }
        )
      }
    );
  }
);
Le.displayName = qe;
var Ve = "TabsContent", Be = a.forwardRef(
  (e, t) => {
    const { __scopeTabs: n, value: o, forceMount: s, children: r, ...i } = e, c = ae(Ve, n), l = Ue(c.baseId, o), u = je(c.baseId, o), g = o === c.value, d = a.useRef(g);
    return a.useEffect(() => {
      const _ = requestAnimationFrame(() => d.current = !1);
      return () => cancelAnimationFrame(_);
    }, []), /* @__PURE__ */ m(Pe, { present: s || g, children: ({ present: _ }) => /* @__PURE__ */ m(
      D.div,
      {
        "data-state": g ? "active" : "inactive",
        "data-orientation": c.orientation,
        role: "tabpanel",
        "aria-labelledby": l,
        hidden: !_,
        id: u,
        tabIndex: 0,
        ...i,
        ref: t,
        style: {
          ...e.style,
          animationDuration: d.current ? "0s" : void 0
        },
        children: _ && r
      }
    ) });
  }
);
Be.displayName = Ve;
function Ue(e, t) {
  return `${e}-trigger-${t}`;
}
function je(e, t) {
  return `${e}-content-${t}`;
}
var $t = Fe, Dt = De, qt = Le, Lt = Be;
function Vt(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var te = { exports: {} };
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
var ve;
function Bt() {
  return ve || (ve = 1, function(e) {
    (function() {
      var t = {}.hasOwnProperty;
      function n() {
        for (var r = "", i = 0; i < arguments.length; i++) {
          var c = arguments[i];
          c && (r = s(r, o.call(this, c)));
        }
        return r;
      }
      function o(r) {
        if (typeof r == "string" || typeof r == "number")
          return this && this[r] || r;
        if (typeof r != "object")
          return "";
        if (Array.isArray(r))
          return n.apply(this, r);
        if (r.toString !== Object.prototype.toString && !r.toString.toString().includes("[native code]"))
          return r.toString();
        var i = "";
        for (var c in r)
          t.call(r, c) && r[c] && (i = s(i, this && this[c] || c));
        return i;
      }
      function s(r, i) {
        return i ? r ? r + " " + i : r + i : r;
      }
      e.exports ? (n.default = n, e.exports = n) : window.classNames = n;
    })();
  }(te)), te.exports;
}
var Ut = Bt();
const ue = /* @__PURE__ */ Vt(Ut), jt = {
  "purpur-tab-content": "_purpur-tab-content_1ugbi_1",
  "purpur-tab-content--force-mount": "_purpur-tab-content--force-mount_1ugbi_15"
}, Gt = ue.bind(jt), be = "purpur-tab-content", Wt = ye(
  ({
    children: e,
    tabId: t,
    "data-testid": n,
    className: o,
    disableForceMount: s,
    ...r
  }, i) => /* @__PURE__ */ m(
    Lt,
    {
      ref: i,
      className: Gt([
        be,
        o,
        { [`${be}--force-mount`]: !s }
      ]),
      "data-testid": n,
      value: t,
      forceMount: !s || void 0,
      ...r,
      children: e
    }
  )
), kt = (e) => !!e && Ye(e) && !!e.props.name && !!e.props.tabId, Kt = {
  "purpur-tab-header": "_purpur-tab-header_18g3c_1",
  "purpur-tab-header--contained": "_purpur-tab-header--contained_18g3c_33",
  "purpur-tab-header--contained-negative": "_purpur-tab-header--contained-negative_18g3c_33",
  "purpur-tab-header--line": "_purpur-tab-header--line_18g3c_36",
  "purpur-tab-header--line-negative": "_purpur-tab-header--line-negative_18g3c_48"
}, zt = ue.bind(Kt), he = "purpur-tab-header", Yt = ye(
  ({
    index: e,
    tabId: t,
    variant: n,
    negative: o,
    onFocus: s,
    "data-testid": r,
    children: i
  }, c) => /* @__PURE__ */ m(
    qt,
    {
      id: `${t}-trigger`,
      className: zt([he, `${he}--${n}${o ? "-negative" : ""}`]),
      value: t,
      "data-testid": r,
      "data-index": e,
      ref: c,
      onFocus: s,
      children: i
    }
  )
), Zt = {
  "purpur-tabs__wrapper": "_purpur-tabs__wrapper_1nygq_1",
  "purpur-tabs__scroll-button": "_purpur-tabs__scroll-button_1nygq_9",
  "purpur-tabs__scroll-button--left": "_purpur-tabs__scroll-button--left_1nygq_71",
  "purpur-tabs__scroll-button--right": "_purpur-tabs__scroll-button--right_1nygq_74",
  "purpur-tabs__wrapper--scroll-end": "_purpur-tabs__wrapper--scroll-end_1nygq_77",
  "purpur-tabs__wrapper--scroll-start": "_purpur-tabs__wrapper--scroll-start_1nygq_80",
  "purpur-tabs--line": "_purpur-tabs--line_1nygq_83",
  "purpur-tabs--line-negative": "_purpur-tabs--line-negative_1nygq_83",
  "purpur-tabs__selected-border": "_purpur-tabs__selected-border_1nygq_91",
  "purpur-tabs__content-wrapper": "_purpur-tabs__content-wrapper_1nygq_115",
  "purpur-tabs--contained": "_purpur-tabs--contained_1nygq_123",
  "purpur-tabs__list": "_purpur-tabs__list_1nygq_123",
  "purpur-tabs--contained-negative": "_purpur-tabs--contained-negative_1nygq_123",
  "purpur-tabs__content-container": "_purpur-tabs__content-container_1nygq_126",
  "purpur-tabs--fullWidth": "_purpur-tabs--fullWidth_1nygq_135"
}, rn = ["line", "contained"], Ht = (e) => new CustomEvent("tabChangeDetail", { detail: { value: e } }), O = ue.bind(Zt), R = "purpur-tabs", Xt = (e, t) => {
  var l;
  if (typeof (e == null ? void 0 : e.getBoundingClientRect) != "function" || typeof (t == null ? void 0 : t.scroll) != "function")
    return;
  const n = e.getBoundingClientRect(), o = t.getBoundingClientRect(), s = t.clientWidth, r = parseInt((l = getComputedStyle(t).borderLeftWidth) == null ? void 0 : l.split("px")[0], 10), i = o.left + (isNaN(r) ? 0 : r);
  let c;
  n.right > o.right && (c = n.left + t.scrollLeft, c = c + n.width - s + s * 0.1, c = c - i), n.left < o.left && (c = n.left + t.scrollLeft, c = c - s * 0.1, c = c - i), c !== void 0 && t.scroll({ left: c, behavior: "smooth" });
}, Jt = ({
  children: e,
  variant: t = "line",
  negative: n = !1,
  fullWidth: o = !1,
  onChange: s,
  className: r,
  defaultValue: i,
  animateHeight: c = !1,
  "data-testid": l,
  value: u,
  ...g
}) => {
  const d = Q(null), [_, v] = B(-1), [f, b] = B({}), [C, h] = B(0), [y, M] = B(0), w = k.toArray(e).filter(kt), N = Q(null), q = Q(new Array(w.length)), U = 200, I = t === "line", X = O([
    R,
    `${R}--${t}${n ? "-negative" : ""}`,
    { [`${R}--fullWidth`]: o },
    r
  ]), $ = k.map(w, ({ props: { tabId: p } }) => p), L = () => {
    const p = $.findIndex((S) => S === i);
    return p >= 0 ? p : 0;
  };
  K(() => {
    u && j(w.findIndex((p) => p.props.tabId === u));
  }, [w, u]);
  const [V, j] = B(L);
  if (new Set($).size !== $.length)
    throw new Error("tabId must be unique");
  const G = (p, S) => S || l ? `${S || l}-${p}` : void 0, W = () => {
    if (!I)
      return;
    const p = q.current[V];
    h((p == null ? void 0 : p.offsetLeft) || 0), M((p == null ? void 0 : p.getBoundingClientRect().width) || 0);
  }, x = (p) => {
    I && !u && j(w.findIndex((S) => S.props.tabId === p)), s == null || s(Ht(p));
  }, Ge = (p) => {
    if (N != null && N.current) {
      const { scrollLeft: S } = N.current, P = p === "left" ? -200 : U;
      N.current.scroll({ left: S + P, behavior: "smooth" });
    }
  }, le = ({ side: p }) => /* @__PURE__ */ m(
    "button",
    {
      className: O(`${R}__scroll-button`, `${R}__scroll-button--${p}`),
      onClick: () => Ge(p),
      type: "button",
      "aria-hidden": "true",
      tabIndex: -1,
      "data-testid": G("scroll-button"),
      children: /* @__PURE__ */ m(we, { svg: p === "left" ? st : it, size: "md" })
    }
  );
  return K(() => {
    const p = () => {
      if (d.current && c) {
        const P = d.current.offsetHeight;
        v(P);
      }
    }, S = () => {
      p(), W();
    };
    return p(), window.addEventListener("resize", S), () => {
      window.removeEventListener("resize", S);
    };
  }, [V, c]), K(() => {
    W();
  }, [V, o, w.length, t]), K(() => {
    const p = (E) => {
      if (E.every((T) => T.isIntersecting) && E.length === w.length) {
        b({});
        return;
      }
      E.forEach((T) => {
        const fe = Number(T.target.getAttribute("data-index")), We = fe === 0, ke = fe === w.length - 1;
        b((Ke) => ({
          ...Ke,
          ...We && {
            [`${R}__wrapper--scroll-end`]: !T.isIntersecting
          },
          ...ke && {
            [`${R}__wrapper--scroll-start`]: !T.isIntersecting
          }
        }));
      });
    }, S = new IntersectionObserver(p, {
      threshold: [0.99],
      root: N.current
    }), P = q.current;
    return P.forEach((E) => S.observe(E)), () => {
      P.forEach((E) => S.unobserve(E));
    };
  }, [w.length]), /* @__PURE__ */ m(
    $t,
    {
      defaultValue: i ?? w[0].props.tabId,
      onValueChange: x,
      "data-testid": l,
      className: X,
      value: u,
      ...g,
      children: /* @__PURE__ */ J("div", { className: O(`${R}__container`), children: [
        /* @__PURE__ */ J("div", { className: O([`${R}__wrapper`, f]), children: [
          /* @__PURE__ */ J(
            Dt,
            {
              ref: (p) => {
                N.current = p;
              },
              className: O(`${R}__list`),
              children: [
                k.map(w, (p, S) => {
                  const { name: P, tabId: E, "data-testid": de } = p.props;
                  return /* @__PURE__ */ m(
                    Yt,
                    {
                      "data-testid": G("header", de),
                      index: S,
                      tabId: E,
                      ref: (T) => {
                        T && (q.current[S] = T);
                      },
                      onFocus: (T) => {
                        Xt(T.target, N.current);
                      },
                      variant: t,
                      negative: n,
                      children: P
                    }
                  );
                }),
                I && /* @__PURE__ */ m(
                  "div",
                  {
                    className: O(`${R}__selected-border`),
                    style: {
                      width: y,
                      transform: `translateX(${C}px)`
                    },
                    "data-testid": G("selected-border")
                  }
                )
              ]
            }
          ),
          /* @__PURE__ */ m(le, { side: "left" }),
          /* @__PURE__ */ m(le, { side: "right" })
        ] }),
        /* @__PURE__ */ m(
          "div",
          {
            className: O(`${R}__content-wrapper`),
            style: { height: c && _ > -1 ? `${_}px` : "auto" },
            children: /* @__PURE__ */ m("div", { ref: d, className: O(`${R}__content-container`), children: k.map(w, (p) => p) })
          }
        )
      ] })
    }
  );
};
Jt.Content = Wt;
export {
  Jt as Tabs,
  Ht as createTabChangeDetailEvent,
  rn as tabsVariants
};
//# sourceMappingURL=tabs.es.js.map
